/* eslint-disable react-refresh/only-export-components */
import { ReactNode } from "react";
import {
  BarChart3,
  BellRing,
  BookOpenText,
  CalendarCheck,
  ClipboardCheck,
  ClipboardList,
  FileText,
  Folder,
  GitBranch,
  History,
  Layers,
  LayoutDashboard,
  Package,
  Settings,
  ShoppingBag,
  Store,
  Users,
  Wallet,
} from "lucide-react";

/**
 * AdminMenuItem.Icon 存的是圖示名稱字串（例如 "Package"），這裡對應到實際的 lucide-react 元件。
 * AdminLayout.tsx（畫側邊選單）跟 AdminMenuItems.tsx（選單維護頁面的圖示選擇器）共用同一份清單，
 * 兩邊看到的圖示選項才會一致；新增分組圖示選項時，只要在這裡加一筆即可。
 */
export const ADMIN_MENU_ICONS: Record<string, ReactNode> = {
  CalendarCheck: <CalendarCheck size={18} />,
  BookOpenText: <BookOpenText size={18} />,
  BarChart3: <BarChart3 size={18} />,
  BellRing: <BellRing size={18} />,
  ClipboardCheck: <ClipboardCheck size={18} />,
  ClipboardList: <ClipboardList size={18} />,
  History: <History size={18} />,
  LayoutDashboard: <LayoutDashboard size={18} />,
  Package: <Package size={18} />,
  ShoppingBag: <ShoppingBag size={18} />,
  Store: <Store size={18} />,
  Users: <Users size={18} />,
  FileText: <FileText size={18} />,
  Settings: <Settings size={18} />,
  Layers: <Layers size={18} />,
  Wallet: <Wallet size={18} />,
  Workflow: <GitBranch size={18} />,
};

export const ADMIN_MENU_ICON_KEYS = Object.keys(ADMIN_MENU_ICONS);

/** 萬一資料庫存了不在清單裡的圖示字串（例如手動改資料庫），fallback 成 Folder 圖示，不會讓整頁選單掛掉。 */
export function resolveAdminMenuIcon(icon: string | null | undefined): ReactNode {
  return (icon && ADMIN_MENU_ICONS[icon]) || <Folder size={18} />;
}
